/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Severity_HintInputs */



/**
* | output |
* | --- |
* | "Warning shows an amber heads-up; critical shows a red disruption notice." |
*
* @param {Partner_Status_Severity_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_severity_hint = /** @type {((inputs?: Partner_Status_Severity_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Severity_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warnung zeigt einen gelben Hinweis; Kritisch zeigt eine rote Störungsmeldung.")
	return /** @type {LocalizedString} */ ("Warning shows an amber heads-up; critical shows a red disruption notice.")
});